import { BFFGateway, TopLeaguesBySportIdRequest, LeaguesResponse } from "sb-resp-lib";
import { DataProvider, LeaguesRetriever } from "../../Typings";

export class TopLeaguesRetriever implements LeaguesRetriever {
    private bff: BFFGateway;
    private dataProvider: DataProvider;
    requestTopLeague: TopLeaguesBySportIdRequest;
    private loadedData: Function;

    constructor(bffGateway: BFFGateway, dataProvider: DataProvider, loadedData: Function) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.requestTopLeague = {};
        this.requestTopLeague.ids = [this.dataProvider.sportId];
        this.requestTopLeague.regionIds = this.dataProvider.regionId;
        this.loadedData = loadedData;
    }

    setRegionIds(regionId: string) {
        this.requestTopLeague.regionIds = this.dataProvider.regionId.concat(regionId);
    }

    removeRegionId() {
        this.requestTopLeague.regionIds = [this.dataProvider.regionId[0]];
    }

    loadData() {
        this.bff.getTopLeaguesBySportId(this.requestTopLeague)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err) });
    }

    private loadDataSuccessCb(response: LeaguesResponse): void {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}